import { render, staticRenderFns } from "./EditEnquiry.vue?vue&type=template&id=390bd920&"
import script from "./EditEnquiry.vue?vue&type=script&lang=js&"
export * from "./EditEnquiry.vue?vue&type=script&lang=js&"
import style0 from "./EditEnquiry.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports